/* eslint-disable no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */

import { TextField } from "@mui/material";
import { Box } from "@mui/system";
import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch } from "react-redux";
import { SyncLoader } from "react-spinners";
import { toast, ToastContainer, Zoom } from "react-toastify";
import { handleAddClose } from "../../../redux/Reducer/ModalSlice";
import { ThemButton } from "../../Login/Login.style";
import { ErrorMessage } from "../../Volunteer/Volunteer.style";

const AddUserLevel = () => {
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState();

  const {
    register,
    formState: { errors },
    handleSubmit,
    control,
    reset,
  } = useForm();

  const onSubmit = (data, e) => {
    // alert(JSON.stringify(data));
    setIsLoading(true);
    const formData = new FormData();
    formData.append("ugleve_name", data.ugleve_name);
    fetch(`http://192.168.0.173/kyamch_ctms_backend_qa/api/createLevel`, {
      // fetch(`http://192.168.0.173/kyamch_ctms_backend_qa/api/createLevel`, {
      method: "POST",
      body: formData,
      // headers: {
      //   "content-type": "application/json",
      // },

      // body: JSON.stringify({
      //   date_of_registration: reg,
      //   full_name: data.full_name,
    })
      .then((res) => {
        // if (res.status === 200) {
        //   //   dispatch(handleAddClose());
        // } else {
        //   alert("User Level not add!!");

        return res.json();
      })
      .then((data) => {
        if (data.data.msg === "Data Insert Successfully") {
          // refetch();
          dispatch(handleAddClose());
        } else if (data.duplicate === true) {
          toast.error("User Level is already exists!!", {
            position: toast.POSITION.TOP_CENTER,
          });
        }
      })
      .finally(() => setIsLoading(false));
    // dispatch(handleAddClose());
  };
  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Box p="20px">
        <TextField
          size="small"
          fullWidth
          label="User level Name*"
          variant="outlined"
          {...register("ugleve_name", {
            required: true,
            pattern: /^[a-zA-Z]+$/,
          })}
        />
        {errors?.ugleve_name?.type === "required" && (
          <ErrorMessage>User level Name is required*</ErrorMessage>
        )}
        {errors?.ugleve_name?.type === "pattern" && (
          <ErrorMessage>Should not allow inserting any symbol</ErrorMessage>
        )}
      </Box>
      <Box sx={{ mb: "15px", display: "flex", justifyContent: "center" }}>
        {isLoading ? (
          <ThemButton
            style={
              {
                //   width: "30%",
              }
            }
            type="submit"
          >
            <SyncLoader color="#FFFFFF" size={8} />
          </ThemButton>
        ) : (
          <ThemButton
            style={
              {
                //   width: "30%",
              }
            }
            type="submit"
          >
            Add User Level
          </ThemButton>
        )}

        <ToastContainer
          autoClose={2000}
          limit={1}
          transition={Zoom}
          toastStyle={{ border: "2px solid crimson" }}
        />

        {/* <ThemButton type="submit">Add User Level</ThemButton> */}
      </Box>
    </form>
  );
};

export default AddUserLevel;
